<template>
  <div>
    <div
        v-if="loader"
        style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; padding-top: 25%; background-color: rgba(255, 255, 255, 0.31);"
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="white"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <!--            <v-layout class="index_header">-->
      <!--                <v-flex xs12 md4 justify-space-around>-->
      <!--                    <v-autocomplete-->
      <!--                        v-model="filters.number"-->
      <!--                        :items="number_list"-->
      <!--                        prepend-icon="mdi-database-search"-->
      <!--                        placeholder="Search By Train Number"-->
      <!--                        :search-input.sync="search_number"-->
      <!--                        item-value="number"-->
      <!--                        item-text="number"-->
      <!--                        clearable-->
      <!--                        @change="searchByNumber()"-->
      <!--                    ></v-autocomplete>-->
      <!--                </v-flex>-->

      <!--            </v-layout>-->
      <v-expansion-panel class="mb-4">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Filters</div>
          </template>
          <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center;">
            <v-flex sm12 md6 lg2>
              <v-text-field
                  solo flat
                  v-model="filters.number"
                  label="Number"
              ></v-text-field>
            </v-flex>
            <v-flex sm12 md6 lg2>
              <v-autocomplete
                  solo flat
                  v-model="filters.speed"
                  :items="speeds"
                  label="Speed"
                  item-text="text"
                  item-value="value">
              </v-autocomplete>
            </v-flex>
            <v-flex sm12 md6 lg3>
              <v-autocomplete
                  :items="lines"
                  name="Lines"
                  label="Select Line"
                  v-model="filters.lines"
                  return-object
                  item-text="name"
                  item-value="id"
                  v-validate="'required'"
                  solo flat
              >
              </v-autocomplete>
            </v-flex>
            <v-flex sm12 md6 lg3>
              <v-autocomplete
                  solo flat
                v-model="filters.properties"
                :loading="loading.properties"
                :items="properties"
                multiple
                item-text="name"
                item-value="id"
                label="Properties">
              </v-autocomplete>
            </v-flex>
            <v-flex sm12 md12 lg2 style="display: flex; justify-content: center; margin-top: -17px;">
              <v-btn @click="applyFilters" color="primary" class="mt-3">
                Filter
              </v-btn>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-data-table
              no-results-text="Loading... Please wait"
              :headers="headers"
              v-model="selected"
              :items="train_list"
              item-key="id"
              :loading="loaders.train_list"
              select-all
              :pagination.sync="pagination"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]"
          >
            <template v-slot:headers="props">
              <tr>
                <th>
                  <v-checkbox
                      :indeterminate="!!unCheckedRows.length"
                      :input-value="props.all"
                      primary
                      hide-details
                      v-model="allSelected"
                      @click.stop="toggleAll"
                  ></v-checkbox>
                </th>
                <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                                        header.sortable !== false ? 'column sortable' : '',
                                        pagination.descending ? 'desc' : 'asc',
                                        header.value === pagination.sortBy ? 'active' : '',
                                    ]"
                    @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small v-if="header.sortable !== false"
                  >arrow_upward
                  </v-icon
                  >
                </th>
                <th>
                  <v-btn icon flat @click="massEdit" color="primary">
                    <v-icon>edit</v-icon>
                    (<small>{{ updatingRecordCount }}</small>)
                  </v-btn>
                </th>
                <th>
                  <span>{{"Actions"}}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                    primary
                    hide-details
                    :value="props.item.number"
                    v-model="checkedRows"
                    @click.stop="toggleRow(props.item.number)"
                    :key="props.item.number"
                ></v-checkbox>
              </td>
              <td>
                <router-link :to="{name:'trainDetail',params:{id:props.item.number} }">
                  {{ props.item.number }}
                </router-link>
              </td>
              <td>
                {{ props.item.name }} ({{ props.item.speed }})
              </td>
              <td>
                {{ props.item.first_station_name }}
                to
                {{ props.item.last_station_name }}
              </td>
              <td>
                {{ props.item.line_name }}
              </td>
              <td>
                <gps-status :status="props.item.gps_enabled"></gps-status>
              </td>
              <td>
                {{ props.item.updated_at | appDateTimeFormat }}
              </td>

              <td>
                <v-tooltip bottom><template v-slot:activator="{ on, attrs }">
                  <v-btn flat icon v-bind="attrs" color="primary" v-on="on" @click="editTrain(props.item.number)">
                    <span class="material-icons">
                      edit
                    </span>
                  </v-btn>
                </template>
                  <span>Edit Train Details</span>
                </v-tooltip>

<!--                <v-btn icon flat @click="editTrain(props.item.number)" color="primary">-->
<!--                  <v-icon>edit</v-icon>-->
<!--                </v-btn>-->
              </td>
<!--              :disabled="user.roles[0].name != 'admin'"-->
              <td>
                <v-menu bottom left >
                  <template v-slot:activator="{ on }">
                    <v-btn
                        dark icon
                        style="color: white; background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%) !important"
                        v-on = "on"
                        depressed>
                     <span class="material-icons">more_vert</span>
                    </v-btn>
                  </template>
                  <v-list>


                    <v-list-tile @click="exportSchedule(props.item.number)">
                      <v-list-tile-title>
<!--                        <span class="material-icons" style="color:orange">file_download</span>-->
                        {{" Download Train Schedule"}}</v-list-tile-title>
                    </v-list-tile>


                    <v-list-tile @click="syncTrainDetails(props.item.number)"
                                 v-if="environment_key == 'LOCAL' || environment_key == 'DEV'">
                      <v-list-tile-title>
<!--                        <span class="material-icons">sync</span>-->
                        {{" Sync to Production"}}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>


<!--                <v-tooltip bottom><template v-slot:activator="{ on, attrs }">-->
<!--                  <v-btn text icon small v-bind="attrs" v-on="on" >-->
<!--                    <span class="material-icons" style="color:orange">-->
<!--                    file_download-->
<!--                    </span>-->
<!--                  </v-btn>-->
<!--                </template>-->
<!--                  <span>Download Schedule</span>-->
<!--                </v-tooltip>-->
              </td>

            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <!-- Delete Resource dialog box -->
      <v-dialog
          v-model="delete_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to delete the announcement?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="confirmDelete">Delete</v-btn>
              <v-btn
                  small
                  color="black"
                  flat
                  type="reset"
                  @click="delete_model = !delete_model"
              >Cancel
              </v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-snackbar
          v-model="snackbar.display"
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          :timeout="snackbar.timeout"
      >
        {{ snackbar.message }}
        <v-btn text dark @click="snackbar.display = false">
          <v-icon right color="white"> close </v-icon>
        </v-btn>
      </v-snackbar>

    </v-container>

    <v-dialog v-model="storeDialog" max-width="1000">
      <v-card>
        <v-card-title class="headline justify-space-between pb-0">
          <span v-if="trainNumber">Update Local Train</span>
          <span v-else>Create Local Train</span>
          <v-btn icon @click="storeDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <train-form :train-number="trainNumber" :key="trainNumber" @success="storeSuccess"></train-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="massUpdateDialog" max-width="500">
      <v-card>
        <v-card-title class="headline justify-space-between pb-0">
          <span>Update {{ updatingRecordCount }} Records</span>
          <v-btn icon @click="massUpdateDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <multi-train-form @success="massUpdateSuccess" :key="massUpdateDialog"
                            :all-selected="allSelected" :checked-rows="checkedRows"
                            :un-checked-rows="unCheckedRows" :filters="filters"
                            :total-records="updatingRecordCount"
          ></multi-train-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import TrainForm from "./TrainForm";
import MultiTrainForm from "./MultiTrainForm";
import GpsStatus from "../Common/GpsStatus";
import moment from "moment";
import store from "../../store";

export default {
  components: {GpsStatus, TrainForm, MultiTrainForm},
  created() {
  },
  computed: {
    ...mapGetters({
      office_location: "get_office_location",
    }),
    updatingRecordCount() {
      return this.allSelected ? (this.total_items - this.unCheckedRows.length) : (this.checkedRows.length);
    }
  },
  watch: {
    'pagination.sortBy': {
      handler() {
        this.getList();
      },
    },
    'pagination.page': {
      handler() {
        this.getList();
      },
    },
    'pagination.rowsPerPage': {
      handler() {
        this.getList();
      },
    },
    'pagination.descending': {
      handler() {
        this.getList();
      },
    },
    // search_number: {
    //     handler(newVal) {
    //         if (newVal != null && newVal.length > 3) {
    //             this.getNumberList(newVal);
    //         }
    //     },
    // },
    // "filters.number": {
    //     handler(value) {
    //         if (value == undefined) {
    //             this.filters.title = "";
    //             this.getList();
    //         }
    //     },
    // },
  },
  methods: {
    getDetails() {
      this.scheduleDialog = false
      this.storeDialog = true;
      let URL = `${process.env.VUE_APP_API_URL}/api/v1/local-trains/`;
      axios
          .get(
               URL + this.trainNumber + '/details',
              { headers: this.$headers }
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.details = response.data.data;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar.display = true;
            this.snackbar.message = "Error Occured";
          })
          .finally(() => {
            {
              this.loaders.train_list = false;
            }
          });
      },
      changeSort(header) {
      if (this.pagination.sortBy != header)
        this.pagination.sortBy = header
      else
        this.pagination.descending = !this.pagination.descending
    },
    searchByNumber() {
      this.getList();
    },
    editTrain(number) {
      this.trainNumber = number
      this.storeDialog = true;
      this.getDetails();
    },
    massEdit() {
      if (!this.allSelected && !this.checkedRows.length) {
        this.snackbar.display = true;
        this.snackbar.message = "No Rows Selected";
      } else {
        this.massUpdateDialog = true
      }
    },
    storeSuccess() {
      this.storeDialog = false
      this.getList()
    },
    massUpdateSuccess() {
      this.massUpdateDialog = false
      this.getList()
    },
    getList: function () {
      this.loaders.train_list = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/trains`, {
            headers: this.$headers,
            params: this.pagination
          })
          .then((response) => {
            if (response.data.status == 1) {
              this.train_list = response.data.trains;
              this.total_items = response.data.total;
              if (this.allSelected) {
                this.selectAll()
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar.display = true;
            this.snackbar.message = "Error Occured";
          })
          .finally(() => {
            {
              this.loaders.train_list = false;
            }
          });

      this.is_loading = false;
    },
    resetFilter() {
      this.$router.replace({
        name: "offices",
        query: {},
      });
      this.getList();
      this.resetFiltersParameters();
      this.is_filtered = false;
      this.filter_dialog_box = false;
      // this.snack_bar.message = "Filter Reset.";
      // this.snack_bar.show = true;
    },
    applyFiltersOnLoad: function () {
      return new Promise((resolve) => {
        this.filters.number = this.$route.query.number;
        this.filters.speed = this.$route.query.speed;
        this.filters.lines = this.$route.query.lines;
        this.filters.properties = this.$route.query.properties;
        resolve()
      })
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },
    selectAll() {
      if (this.unCheckedRows.length)
        this.checkedRows = this.train_list.filter((item) => !this.unCheckedRows.includes(item.number)).map((item) => item.number)
      else
        this.checkedRows = this.train_list.map((item) => item.number)
    },
    toggleAll() {
      this.unCheckedRows = [];
      if (this.checkedRows.length) {
        this.checkedRows = [];
        this.allSelected = false;
      } else {
        this.selectAll()
        this.allSelected = true;
      }
    },
    toggleRow(number) {
      if (this.allSelected) {
        const numberIndex = this.unCheckedRows.indexOf(number)
        if (numberIndex === -1) {
          this.unCheckedRows.push(number)
        } else {
          this.unCheckedRows.splice(numberIndex, 1)
        }
      }
      const checkedIndex = this.checkedRows.indexOf(number)
      if (checkedIndex === -1) {
        this.checkedRows.push(number)
      } else {
        this.checkedRows.splice(checkedIndex, 1)
      }
    },
    confirmDelete: function () {
      this.loader = true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/delete-announcement`,
              {announcement_id: this.announcement_item.id},
              {headers: this.$headers}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.loader = false;
              this.delete_model = false;
              this.snackbar.display = true;
              this.snackbar.message = response.data.message;
            }
          })
          .catch((error) => {
          })
          .finally(() => {
          });
    },
    getNumberList: function (newVal) {
      this.loaders.train_list = true;
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/search-trains`,
              {headers: this.$headers, params: {number: newVal}}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.number_list = response.data.local_trains;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar.display = true;
            this.snackbar.message = "Error Occured";

          })
          .finally(() => {
            {
              this.loaders.train_list = false;
            }
          });
      this.is_loading = false;
    },
    getLinesList() {
      this.loading.lines = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/lines`, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.lines = response.data.data
            }
          })
          .finally(() => {
            this.loading.lines = false
          })
    },
    getExceptionDaysList() {
      this.loading.exceptionDays = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/exception_days`)
          .then((response) => {
            if (response.data.status == 1) {
              this.exceptionDays = response.data.data
            }
          })
          .finally(() => {
            this.loading.exceptionDays = false
          })
    },
    getPropertiesList() {
      this.loading.properties = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-properties`)
          .then((response) => {
            if (response.data.status == 1) {
              this.properties = response.data.data
            }
          })
          .finally(() => {
            this.loading.properties = false
          })
    },
    applyFilters() {
      this.allSelected = false
      this.unCheckedRows = []
      this.getList()
    },

    download(train_number, data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      var month = moment(this.pagination.start_date).format('MMMM');
      link.setAttribute('download',
      'Train_Schedule_'+ train_number + moment().format('YYYY-MM-DD')
          +'.csv');
      document.body.appendChild(link);
      link.click();
    },
    exportSchedule(number){
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/export-train-schedule`,
          {train_number : number},{headers: this.$headers, responseType: 'blob'})
          .then((response) =>{
        this.download(number ,response.data);

      }).catch((error) => {
        console.warn(error);
        this.snackbar.display = true;
        this.snackbar.message = "Something Went Wrong";
      }).finally(() => {
        this.stopLoading()
      })
    },
    startLoading() {
      store.dispatch('startLoader');
    },
    stopLoading() {
      store.dispatch('stopLoader');
    },
    syncTrainDetails(number){
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/sync-train-details`,
          {train_number : number},{headers: this.$headers})
          .then((response) =>{
          if(response.data.status == 1){
            this.snackbar.display = true;
            this.snackbar.message = response.data.message;
          }else if(response.data.status == 0){
            this.snackbar.display = true;
            this.snackbar.message = response.data.message;
          }
      }).catch((error) =>{
        console.warn(error);
        this.snackbar.display = true;
        this.snackbar.message = "Something Went Wrong";
      }).finally(() => {
        this.stopLoading();
      })
    }
  },
  data: () => {
    return {
      checkedRows: [],
      unCheckedRows: [],
      allSelected: false,
      speeds: [{text: 'All', value: null}, {text: 'Slow', value: 'S'}, {text: 'Fast', value: 'F'}],
      loading: {
        exceptionDays: false,
        lines: false,
        properties: false,
      },
      exceptionDays: [],
      lines: [],
      properties: [],
      trainNumber: null,
      storeDialog: false,
      massUpdateDialog: false,
      announcement_item: {},
      number_list: [],
      search_number: "",
      delete_model: false,
      is_selected_all: false,
      all_selected_items: [],
      selected: [],
      is_filtered: false,
      loader: false,
      filter_key_count: -1,
      pagination: {sortBy: "updated_at", descending: true, rowsPerPage: 10},
      filters: {
        number: '',
        speed: null,
        lines: [],
        properties: []
      },
      filter_dialog_box: false,
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
      total_items: 0,
      headers: [
        {
          text: "Number",
          value: "number",
          align: "left",
          sortable: true,
        },
        {
          text: "Name",
          value: "name",
          align: "left",
          sortable: true,
        },
        {
          text: "From / To",
          value: "first_stations.name",
          align: "left",
          sortable: true,
        },
        {
          text: "Line",
          value: "local_lines.name",
          sortable: true,
        },
        {
          text: "GPS Enabled",
          value: "gps_enabled",
          sortable: true,
        },
        {
          text: "Updated At",
          value: "updated_at",
          sortable: true,
        },
      ],
      train_list: [],
      add_new_office_model: false,
      new_office: {
        name: "",
      },
      loaders: {
        train_list: false,
        new_office_submit_loader: false,
      },
      auth_user: {
        roles: [{}],
      },
      environment_key : '',
    };
  },
  mounted() {
    this.getLinesList()
    this.getExceptionDaysList()
    this.getPropertiesList()
    this.getList();
    this.applyFiltersOnLoad();
    this.auth_user = this.$store.getters.get_user;
    // console.log(this.auth_user)
    this.environment_key =  process.env.VUE_APP_ENVIRONMENT_KEY;
    // console.warn(process.env.VUE_APP_ENVIRONMENT_KEY);
  }
};
</script>


